import { useState } from 'react';

const toLocalDate = (d = new Date()) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

const getYesterday = () => {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    return toLocalDate(d);
};

const useStreak = () => {
    const [streak] = useState(() => {
        const today = toLocalDate();
        const yesterday = getYesterday();

        let stored = null;
        try {
            stored = JSON.parse(localStorage.getItem('captions_streak') || 'null');
        } catch {}

        if (!stored) {
            localStorage.setItem('captions_streak', JSON.stringify({ streak: 1, lastVisit: today }));
            return 1;
        }

        if (stored.lastVisit === today) return stored.streak;

        const next = stored.lastVisit === yesterday ? stored.streak + 1 : 1;
        localStorage.setItem('captions_streak', JSON.stringify({ streak: next, lastVisit: today }));
        return next;
    });

    return streak;
};

export default useStreak;
